/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Form_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Style Guide Review" |
*
* @param {Style_Guide_Form_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_form_aria_label = /** @type {((inputs?: Style_Guide_Form_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Form_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Examen du guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stilrichtlinien-Überprüfung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Revisione della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обзор руководства по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Revisión de la guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风格指南审查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड समीक्षा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Revisão do Guia de Estilo")
	return /** @type {LocalizedString} */ ("Style Guide Review")
});